import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {IntegrationTypeModel} from '../../../models/api/integrationTypesModel';
import {SettingsAppsAllUrl} from '../../../models/url/settingsUrlModel';
import {AppState} from '../../../store/appState';
import {
  getAlphabeticalSortedIntegrationTypes,
  getIsIntegrationTypesLoading,
} from '../../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsAllPage} from './settingsAppsAllPage';

/*
 * Props.
 */

interface SettingsAppsAllPageContainerProps {
  url: SettingsAppsAllUrl;
}

/*
 * Selectors.
 */

function getSearchQuery(_state: AppState, props: SettingsAppsAllPageContainerProps) {
  return props.url.searchQuery || '';
}

export const getIntegrationTypesFromQuery = createSelector(
  [getSearchQuery, getAlphabeticalSortedIntegrationTypes],
  (searchQuery, integrationTypes) =>
    _(integrationTypes)
      .filter((integrationType) => shouldDisplayIntegrationType(searchQuery, integrationType))
      .value(),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsAllPageContainerProps>()(() => ({
  integrationTypes: getIntegrationTypesFromQuery,
  isIntegrationTypesLoading: getIsIntegrationTypesLoading,
}));

export const SettingsAppsAllPageContainer = connect(mapStateToProps)(SettingsAppsAllPage);

/*
 * Helpers.
 */

function shouldDisplayIntegrationType(searchQuery: string, integrationType: IntegrationTypeModel) {
  if (!searchQuery) {
    return true;
  }
  const normalizedSearchQuery = searchQuery.toLocaleLowerCase().trim();

  if (integrationType.name.toLowerCase().includes(normalizedSearchQuery)) {
    return true;
  }
  return integrationType.searchKeywords.some((k) => k.toLowerCase().includes(normalizedSearchQuery));
}
